// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"224":"component---src-pages-xindex-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"224":"f22f3ce12cdfa9bbbd4f","678":"16178d319f9feb12474d","883":"298dfe9458f2b9eed19c"}[chunkId] + ".js";
};